import { useParams } from 'react-router-dom';

import { Paper, useTheme, Grid, Box } from '@mui/material';

import TicketsManager from '../../components/TicketsManagerTabs';
import Ticket from '../../components/Ticket';

import { QueueSelectedProvider } from '../../context/QueuesSelected/QueuesSelectedContext';

import logo from '../../assets/logo.png';
import logoDark from '../../assets/logo-black.png';

import { getStyled } from './styles';

const TicketsCustom = () => {
  const theme = useTheme();
  const classes = getStyled(theme);
  const { ticketId } = useParams();

  return (
    <QueueSelectedProvider>
      <div style={classes.chatContainer}>
        <div style={classes.chatPapper}>
          <Grid container spacing={0} style={classes.gridContainer}>
            <Grid size={3} sx={classes.contactsWrapper}>
              <TicketsManager />
            </Grid>
            <Grid size={9} sx={classes.messagesWrapper}>
              {ticketId ? (
                <Ticket />
              ) : (
                <Paper square variant='outlined' sx={classes.welcomeMsg}>
                  <img
                    style={classes.logo}
                    src={theme.palette.mode === 'dark' ? logoDark : logo}
                    alt='Logo'
                  />
                </Paper>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    </QueueSelectedProvider>
  );
};

export default TicketsCustom;
